export const loginByEmailForm = {
  Email: 'email',
  EmailSignInWithCodeBtn: 'email-signin-with-code-btn',
  EmailSignInWithPasswordBtn: 'email-signin-with-password-btn',
  EmailSignInWithCodeSmsBtn: 'email-signin-with-code-sms-btn',
  ContinueBtn: 'continue-btn',
};
